export function typeSafeObjectKeys<T extends Object>(obj: T): Array<keyof T> {
  const keys = []
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      keys.push(key)
    }
  }
  return keys
}
